module.exports = __webpack_public_path__ + "assets/img/detail-content-img-1-c87be33f.jpg";